'use client';

import { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { PartCardLarge } from '@qb/frontend/components/PartCards/PartCardLarge';
import { BaseCarousel } from '@/components/Common/BaseCarousel/BaseCarousel';
import { useRequestPartPriceFromSPW } from '@/hooks/useRequestPartPriceFromSPW';
import { PopularProductsParams } from '@/shared/classes/SPSPageComponentParams/PopularProductsParams';
import { TenantConfig } from '@/shared/types/controllers/sps/SPSAppControllerTypes';
import { PartPopularPartsDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';

// hardcoded now for popular parts
const SHIP_PROCESSING_DAYS = 0;
type PopularProductsWithDiscountsProps = {
  tenantConfig: TenantConfig;
  params: PopularProductsParams;
  popularProducts: PartPopularPartsDataResponse['parts'];
};
export const PopularProductsWithDiscounts = ({
  tenantConfig,
  params,
  popularProducts
}: PopularProductsWithDiscountsProps) => {
  const {
    authUser,
    requestMultiplePartsPrices,
    getPartPrice
  } = useRequestPartPriceFromSPW();
  useEffect(() => {
    const partIDs = popularProducts.map(({
      id
    }) => id);

    /**
     * Request the prices for the popular products.
     */
    requestMultiplePartsPrices(partIDs);
  }, [getPartPrice, popularProducts, requestMultiplePartsPrices]);
  const popularProductsWithDiscounts = popularProducts.map(part => ({
    ...part,
    ...getPartPrice(part.id)
  }));
  const productsCount = popularProducts.length ?? 0;
  return <Box sx={{
    bgcolor: 'common.backgroundColor',
    py: 5
  }} data-sentry-element="Box" data-sentry-component="PopularProductsWithDiscounts" data-sentry-source-file="PopularProductsWithDiscounts.tsx">
      <Container component="section" data-sentry-element="Container" data-sentry-source-file="PopularProductsWithDiscounts.tsx">
        <Typography component="h2" sx={{
        typography: {
          xs: 'h4',
          md: 'h3'
        },
        mb: {
          xs: 3,
          md: 4
        }
      }} data-sentry-element="Typography" data-sentry-source-file="PopularProductsWithDiscounts.tsx">
          {params.title ?? 'Popular products'}
        </Typography>
        <Box sx={{
        px: [1, 1, 2]
      }} data-sentry-element="Box" data-sentry-source-file="PopularProductsWithDiscounts.tsx">
          <BaseCarousel slidesCount={productsCount} slidesToShow={{
          xs: 2,
          sm: 3,
          md: 4,
          lg: 5,
          xl: 5
        }} data-sentry-element="BaseCarousel" data-sentry-source-file="PopularProductsWithDiscounts.tsx">
            {popularProductsWithDiscounts.map(part => <Box key={part.id} sx={{
            px: {
              xs: 1
            }
          }}>
                <PartCardLarge tenantConfig={tenantConfig} authUserCompanyName={authUser?.company?.name} part={{
              ...part,
              price: part.price ?? undefined,
              originalPrice: part.originalPrice ?? undefined,
              shipProcessingDays: SHIP_PROCESSING_DAYS
            }} />
              </Box>)}
          </BaseCarousel>
        </Box>
      </Container>
    </Box>;
};